import {AfterViewInit, Component, DoCheck, Input, OnInit} from '@angular/core';
import {TaxNews} from '../models/power-search.model';
import {Router} from '@angular/router';

@Component({
    standalone: false,
    selector: 'particle-tax-news',
  templateUrl: './tax-news.component.html',
  styleUrls: ['./tax-news.component.scss']
})
export class TaxNewsComponent implements OnInit, DoCheck {
  @Input()taxNews: TaxNews[];
  constructor(private router: Router) { }

  ngOnInit() {
  }

  onClickedViewAll() {
    this.router.navigateByUrl('/home/tax-news/date');
  }

  ngDoCheck(): void {

  }

  onClickedNewsItem(index: number) {
    const url = 'taxnews/article?id=' + this.taxNews[index].id.toString();
    this.router.navigateByUrl(url);
  }
}
